import { updateDomComponent } from '@theme/critical';

class PredictiveSearch extends HTMLElement {
    constructor() {
        super();

        this.header = document.querySelector('header.top');
        this.input = this.querySelector('input[type="text"]');
        this.input.addEventListener('input', this.debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));

        document.getElementById('search-toggle').addEventListener('click', (ev) => {
            ev.preventDefault
            this.classList.toggle('is-open');
             this.header.classList.toggle('is-open', this.classList.contains('is-open')); // Esempio: mostra/nascondi header
        });
    }

    onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
            return;
        }

        this.getSearchResults(searchTerm);
    }

    async getSearchResults(searchTerm) {
        const url = `/search/suggest?q=${searchTerm}&resources[limit]=5&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.title,body,variants.sku,vendor`;

        console.log(url);
        const response = await updateDomComponent(
            [{ source: '#predictive-search-results-list', target: '#predictive-search-results'}],
            ['predictive-search'],
            url,
            { mode: 'innerHtml', returnDocument: false }
        )

        document.getElementById('predictive-search-results').innerHTML = response['predictive-search'];
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}

if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch);
}